// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "typewriter-module--base-text-alt--global--4aa73";
export var baseTextGlobal = "typewriter-module--base-text--global--da185";
export var blockSpacing100 = "typewriter-module--block-spacing-100--1bc29";
export var blockSpacing50 = "typewriter-module--block-spacing-50--30bdb";
export var blockVPadding100 = "typewriter-module--block-v-padding-100--c80dd";
export var blockVPadding50 = "typewriter-module--block-v-padding-50--2ca4c";
export var captionTextGlobal = "typewriter-module--caption-text--global--eecab";
export var cmsRenderedContentGlobal = "typewriter-module--cms-rendered-content--global--ec42b";
export var container = "typewriter-module--container--a0626";
export var defaultHSpacingGlobal = "typewriter-module--default-h-spacing--global--7b1e0";
export var fadeInAnimation = "typewriter-module--fadeInAnimation--5fdfd";
export var fadeInOnLoadGlobal = "typewriter-module--fade-in-on-load--global--acec9";
export var fullHeightGlobal = "typewriter-module--full-height--global--f21ce";
export var fullHeightOmittingNavGlobal = "typewriter-module--full-height-omitting-nav--global--c3d0d";
export var headingTextGlobal = "typewriter-module--heading-text--global--51194";
export var ingressTextGlobal = "typewriter-module--ingress-text--global--134e6";
export var linkColorChangeTransitionGlobal = "typewriter-module--link-color-change-transition--global--20cde";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "typewriter-module--page-heading-text--global--efee1";
export var paragraphTextGlobal = "typewriter-module--paragraph-text--global--1b3c5";
export var placeholder = "typewriter-module--placeholder--ce8da";
export var subheadingTextGlobal = "typewriter-module--subheading-text--global--95d8f";
export var text = "typewriter-module--text--bdfc2";